import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

import { stats } from '@/constants/content'

const HighlightsSection: FC = (): ReactNode => {
    return (
        <section id='highlights' aria-label="Webify at a glance" className='relative z-10 -mt-20 px-5 sm:px-6 lg:-mt-24 lg:px-8'>
            <div className='mx-auto grid max-w-7xl grid-cols-2 overflow-hidden rounded-2xl bg-card shadow-xl shadow-ink/10 ring-1 ring-border lg:grid-cols-4'>
                {stats.map((stat, index) => (
                    <div
                        key={stat.label}
                        className={cn(
                            'border-border p-5 sm:p-8',
                            index % 2 === 1 && 'border-l',
                            index >= 2 && 'border-t lg:border-t-0',
                            index === 2 && 'lg:border-l'
                        )}
                    >
                        <p className='font-heading text-4xl font-semibold tracking-tight text-foreground sm:text-5xl'>
                            {stat.value}
                            {stat.suffix && <span className='text-primary'>{stat.suffix}</span>}
                        </p>

                        <p className='mt-3 text-sm font-semibold text-foreground'>
                            {stat.label}
                        </p>

                        <p className='mt-1 text-sm leading-snug text-muted-foreground'>
                            {stat.detail}
                        </p>
                    </div>
                ))}
            </div>
        </section>
    )
}

export default HighlightsSection
